import  { useContext } from "react";
import { Modal, Table, Tag, Tooltip } from "antd";
import GlobalContext from "../../../context/GlobalContext";
import { useTranslation } from "react-i18next";

const ModalValidPlanning = (props) => {
  const {
    openModal,
    setOpenModal,
    modules,
    setCurrentStep,
    currentStep,
    plagesMultiple,
  } = props;
  const { globalData } = useContext(GlobalContext);
  const { t } = useTranslation();

  // const plagesMultiple = {
  //   stage: [
  //     formValues.periode_stage_integration && {
  //       stage_integration: {
  //         start: formValues.periode_stage_integration.start,
  //         end: formValues.periode_stage_integration.end,
  //       },
  //       stageType: "intégration",
  //     },
  //     formValues.periode_stage_obseravation && {
  //       stage_observation: {
  //         start: formValues.periode_stage_obseravation.start,
  //         end: formValues.periode_stage_obseravation.end,
  //       },
  //       stageType: "observation",
  //     },
  //   ].filter(Boolean),

  //   examen: (formValues.semaines_examen?.[0]?.items || []).filter(
  //     (v) => v && typeof v === "object"
  //   ),

  //   vacances: (formValues.semaines_vacances?.[0]?.items || []).filter(
  //     (v) => v && typeof v === "object"
  //   ),

  //   rattrapage: (formValues.semaines_rattrapage?.[0]?.items || []).filter(
  //     (v) => v && typeof v === "object"
  //   ),
  // };

  // const transformedDataStages = insertSpecialLines(data, plagesMultiple);
  const expandSpecialStageRows = () => {
    const result = [];
    let globalWeekCounter = 1;

    openModal.forEach((row) => {
      const duration =
        row?.typeStage?.stageType === "intégration"
          ? parseInt(globalData?.duree_stage_mois_integration *4)
          : parseInt(globalData?.duree_stage_mois_observation * 4);
      if (
        row.type === "special" &&
        row.specialType === "stage" &&
        duration > 1
      ) {
        for (let i = 0; i < duration; i++) {
          result.push({
            ...row,
            cloneIndex: i + 1,
            displayLabel: `Semaine de stage N°${globalWeekCounter++}`,
          });
        }
      } else if (row.type === "special" && row.specialType === "stage") {
        result.push({
          ...row,
          displayLabel: `Semaine de stage N°${globalWeekCounter++}`,
        });
      } else if (row.type === "normal") {
        result.push({
          ...row,
          displayLabel: `Semaine formation N°${globalWeekCounter++}`,
        });
      } else {
        result.push(row);
      }
    });

    return result;
  };
  const stageObs = globalData?.periode_stage_obseravation;
  const stageInt = globalData?.periode_stage_integration;
  const weeksObs = parseInt(globalData?.nbre_semaines_stage_observation || 0);
  const weeksInt = parseInt(globalData?.nbre_semaines_stage_integration || 0);
  const recapModulesColumns = [
    {
      title: t("Période"),
      dataIndex: "periode",
      render: (_, row) => {
        if (row.type === "year") {
          return {
            children: null,
            props: { rowSpan: 0 },
          };
        }

        if (row.type === "special") {
          return { children: null, props: { rowSpan: 0 } };
        }

        const type = globalData.type_periode;

        const semainesParPeriodeList = [];
        let i = 1;
        while (true) {
          const value = parseInt(globalData[`nbre_semaines_periode_${i}`]);
          if (isNaN(value)) break;
          semainesParPeriodeList.push(value);
          i++;
        }

        const weekIndex = row.weekIndex;

        let cumulative = 0;
        let periodeIndex = -1;

        for (let j = 0; j < semainesParPeriodeList.length; j++) {
          cumulative += semainesParPeriodeList[j];
          if (weekIndex < cumulative) {
            periodeIndex = j;
            break;
          }
        }

        if (periodeIndex === -1)
          return { children: null, props: { rowSpan: 0 } };

        const periodeNom =
          type === "Semestrielle"
            ? `Semestre ${periodeIndex + 1}`
            : `Trimestre ${periodeIndex + 1}`;

        const debutPeriode = semainesParPeriodeList
          .slice(0, periodeIndex)
          .reduce((a, b) => a + b, 0);

        const finPeriode =
          debutPeriode + semainesParPeriodeList[periodeIndex] - 1;

        const lignesDansPeriode = expandSpecialStageRows().filter((r) => {
          const idx =
            typeof r.weekIndex === "number" ? r.weekIndex : r.startWeek;
          return idx >= debutPeriode && idx <= finPeriode;
        });

        const isFirstRow = row.weekIndex === debutPeriode;

        if (isFirstRow) {
          return {
            children: periodeNom,
            props: {
              rowSpan: lignesDansPeriode.length,
            },
          };
        }

        return { children: null, props: { rowSpan: 0 } };
      },
      // width:120
    },
    {
      title: t("Semaine"),
      dataIndex: "week",
      render: (value, row) => {
        if (row.type === "year") {
          return {
            children: (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  textAlign: "center",
                }}
              >
                {row.yearLabel}
              </div>
            ),
            props: {
              colSpan: recapModulesColumns.length,
            },
          };
        }

        if (row.displayLabel) {
          if (row.specialType === "stage") {
            return {
              children: <Tag color="blue">{row.displayLabel}</Tag>,
            };
          }
          return row.displayLabel;
        }

        if (row.type === "special") {
          const tagColors = {
            stage: "blue",
            examen: "red",
            rattrapage: "gold",
            vacances: "orange",
          };

          const tagColor = tagColors[row.specialType] || undefined;

          return {
            children: <Tag color={tagColor}>{row.label}</Tag>,
            props: {},
          };
        }

        return "";
      },
    },

    ...(modules?.[0]?.items || []).map((mod, index) => ({
      title: <Tooltip title={mod?.intitulé}>{`M${
              mod?.type === "Général"
                ? import.meta.env.VITE_APP_TYPE_MODULE_GENERAL
                : import.meta.env.VITE_APP_TYPE_MODULE_SPECIFIQUE
            }${index + 1}`}</Tooltip>,
      dataIndex: mod?.intitulé,
      render: (_, row) => {
        // const value = globalData[`${mod.intitulé}${index +1}`];
        if (row.type === "year") {
          return {
            children: null,
            props: { colSpan: 0, style: { display: "none" } },
          };
        }
        if (row.type === "special") {
          return { children: null, props: { colSpan: 0 } };
        }
          const semaineIndex = row.weekIndex + 1;
        const value = globalData?.[`${mod.intitulé}${semaineIndex}`] || 0;
        return `${value} h`;
      },
    })),
    {
      title: t("Charge hebdo"),
      render: (_, row) => {
        if (row.type === "year") {
          return {
            children: null,
            props: { colSpan: 0, style: { display: "none" } },
          };
        }

        if (row.type === "special") {
          const iconMap = {
            stage: "🟦",
            examen: "🟥",
            rattrapage: "🟨",
            vacances: "🟧",
          };

          const icon = iconMap[row.specialType] || "⬜";
          const label =
            row.specialType.charAt(0).toUpperCase() + row.specialType.slice(1);

          // Chercher la plage correspondante
          const plages = plagesMultiple?.[row.specialType] || [];
          const plage = plages.find((p) => {
            const periode = Object.values(p).find(
              (val) =>
                val && typeof val === "object" && val.start === row.startWeek
            );
            return !!periode;
          });

          let suffix = "";

          if (row.specialType === "stage") {
            const stageType = plage?.stageType || "";

            suffix = ` – ${stageType}`;
          } else {
            const nbreJours =
              plage?.nbre_vacances_periode ||
              plage?.nbre_rattrapage_periode ||
              plage?.nbre_examen_periode;

            suffix = nbreJours ? ` – ${nbreJours} jours` : "";
          }

          return {
            children: (
              <strong style={{ display: "block", textAlign: "center" }}>
                {`${icon} ${label}${suffix}`}
              </strong>
            ),
            props: {
              colSpan: recapModulesColumns.length,
            },
          };
        }

        let total = 0;

        // Additionner les heures stockées par semaine pour chaque module
        modules[0].items.forEach((mod) => {
          const semaineVal =
            globalData?.[`${mod.intitulé}${row.week}`] ||
            row[mod.intitulé] ||
            0;
          total += typeof semaineVal === "number" ? semaineVal : 0;
        });

        // Ajouter les heures stage observation si applicable
        if (
          row.week - 1 >= stageObs?.start &&
          row.week - 1 < stageObs?.start + weeksObs
        ) {
          total += globalData?.duree_stage_heures_observation || 0;
        }

        // Ajouter les heures stage intégration si applicable
        if (
          row.week - 1 >= stageInt?.start &&
          row.week - 1 < stageInt?.start + weeksInt
        ) {
          total += globalData?.duree_stage_heures_integration || 0;
        }

        return `${total} h`;
      },
    },
  ];

  return (
    <Modal
      open={openModal.length > 0}
      onCancel={() => setOpenModal([])}
      width="90%"
      onOk={() => {
        setCurrentStep(5);
        setOpenModal([]);
      }}
      okText={t("Confirmer")}
      title={t("Confirmer le planning")}
    >
      <Table
        style={{ width: "100%" }}
        columns={recapModulesColumns}
        dataSource={expandSpecialStageRows()}
        rowClassName={(record) =>
          record.type === "special"
            ? "row-total-colored"
            : record?.type === "year" || record?.isYearRow
            ? "row-year-colored"
            : ""
        }
        pagination={false}
      />
    </Modal>
  );
};

export default ModalValidPlanning;
